import Cookies from 'js-cookie'
const state = {
    accessToken: Cookies.get('token') ? Cookies.get('token') : '',
    adminID: Cookies.get('a_token') ? Cookies.get('a_token') : '',
    isNeedComplate: Cookies.get('isNeedComplate') ? Cookies.get('isNeedComplate') : 1,
    isNeedEditPwd: Cookies.get('isNeedEditPwd') ? Cookies.get('isNeedEditPwd') : 0,
    
    isSys: Cookies.get('isSys') ? Cookies.get('issys') : 1,
    adminRegionLevel: Cookies.get('adminRegionLevel') ? Cookies.get('adminRegionLevel') : '',
    adminRegionLevelName: Cookies.get('adminRegionLevelName') ? Cookies.get('adminRegionLevelName') : '',
    adminRegionID: Cookies.get('adminRegionID') ? Cookies.get('adminRegionID') : '',
    currentApplicationYear: Cookies.get('currentApplicationYear') ? Cookies.get('currentApplicationYear') : '',
}

const mutations = {
    SET_TOKEN: (state, token) => {
        Cookies.set('token', 'Bearer ' + token)
        state.accessToken = 'Bearer ' + token
    },
    SET_AdminID: (state, adminID) => {
        Cookies.set('a_token', adminID)
        state.adminID = adminID
    },
    SET_AdminRegionLevel: (state, adminRegionLevel) => {
        Cookies.set('adminRegionLevel', adminRegionLevel)
        state.adminRegionLevel = adminRegionLevel
    },
    SET_AdminRegionLevelName: (state, adminRegionLevelName) => {
        Cookies.set('adminRegionLevelName', adminRegionLevelName)
        state.adminRegionLevelName = adminRegionLevelName
    },
    SET_AdminRegionID: (state, adminRegionID) => {
        Cookies.set('adminRegionID', adminRegionID)
        state.adminRegionID = adminRegionID
    },
    SET_Issys: (state, isSys) => {
        Cookies.set('issys', isSys)
        state.isSys = isSys
    },
    SET_IsNeedComplate: (state, isNeedComplate) => {
        Cookies.set('isNeedComplate', isNeedComplate)
        state.isNeedComplate = isNeedComplate
    },
    SET_isNeedEditPwd: (state, isNeedEditPwd) => {
        Cookies.set('isNeedEditPwd', isNeedEditPwd)
        state.isNeedEditPwd = isNeedEditPwd
    },
    SET_currentApplicationYear: (state, currentApplicationYear) => {
        Cookies.set('currentApplicationYear', currentApplicationYear)
        state.currentApplicationYear = currentApplicationYear
    },
    
    REMOVE_TOKEN: (state) => {
        Cookies.remove('token')
        state.accessToken = ''
    },
    REMOVE_ADMINID: (state) => {
        Cookies.remove('a_token')
        state.adminID = ''
    }
}
const actions = {
    setToken({ commit }, token) {
        return new Promise(resolve => {
            commit('SET_TOKEN', token)
            resolve()
        })
    },
    setAdminID({ commit }, adminID) {
        return new Promise(resolve => {
            commit('SET_AdminID', adminID)
            resolve()
        })
    },
    setAdminRegionLevel({ commit }, adminRegionLevel) {
        return new Promise(resolve => {
            commit('SET_AdminRegionLevel', adminRegionLevel)
            resolve()
        })
    },
    setAdminRegionLevelName({ commit }, adminRegionLevelName) {
        return new Promise(resolve => {
            commit('SET_AdminRegionLevelName', adminRegionLevelName)
            resolve()
        })
    },
    setAdminRegionID({ commit }, adminRegionID) {
        return new Promise(resolve => {
            commit('SET_AdminRegionID', adminRegionID)
            resolve()
        })
    },
    setISSYS({ commit }, isSys) {
        return new Promise(resolve => {
            commit('SET_Issys', isSys)
            resolve()
        })
    },
    setIsNeedComplate({ commit }, isNeedComplate) {
        return new Promise(resolve => {
            commit('SET_IsNeedComplate', isNeedComplate)
            resolve()
        })
    },
    setisNeedEditPwd({ commit }, isNeedEditPwd) {
        return new Promise(resolve => {
            commit('SET_isNeedEditPwd', isNeedEditPwd)
            resolve()
        })
    },

    setCurrentApplicationYear({ commit }, currentApplicationYear) {
        return new Promise(resolve => {
            commit('SET_currentApplicationYear', currentApplicationYear)
            resolve()
        })
    },

    removeToken({ commit }) {
        return new Promise(resolve => {
            commit('REMOVE_TOKEN')
            resolve()
        })
    },
    removeAdminID({ commit }) {
        return new Promise(resolve => {
            commit('REMOVE_ADMINID')
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}